import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import TinyNodeParkinglocationsTable from '../components/TinyNodeParkinglocationsTable';
import TinyNodeParkinglocationsForm from '../components/TinyNodeParkinglocationsForm';

import TinyNodeParkinglocationsModel from '../components/TinyNodeParkinglocationsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Icon, DatePicker, message } from 'antd';

class TinyNodeParkinglocationsScreen extends Component {

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    tinyNodeParkinglocationsFormModalVisible: false,
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      dataLoading: true
    });
    TinyNodeParkinglocationsModel.getAll()
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => { return d['serialNumber'].startsWith(searchText); })
    })
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>TinyNode - Seznam lokalit</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
              </Col>
              <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData() }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ tinyNodeParkinglocationsFormModalVisible: true }) }}>Nová lokalita</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <TinyNodeParkinglocationsForm
            type="modal"
            modalVisible={this.state.tinyNodeParkinglocationsFormModalVisible}
            onModalCancel={() => { this.setState({ tinyNodeParkinglocationsFormModalVisible: false }) }}
            onSuccess={(form, values) => {
              TinyNodeParkinglocationsModel.create(values)
                .then(() => {
                  form.resetFields();
                  this.loadData();
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />
          <TinyNodeParkinglocationsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onDetailRow={(record) => {
            }}
            onRemoveRow={(id) => {
              TinyNodeParkinglocationsModel.remove(id)
                .then(() => {
                  this.loadData();
                });
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default TinyNodeParkinglocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/TinyNodeParkinglocationsScreen.js